// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hUTn","content":"styles_content__1XTmK","tableWrap":"styles_tableWrap__3VU8W"};